import React, { useState } from "react";

import { Dialog, CloseButton, Button, Input, Portal } from "@chakra-ui/react";
import { getRandomLightColor, showToast } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersApprovalGenerateRoute = () => {
  // state
  const layersApprovalGenerateRouteDialog = useAppStore((s) => s.layersApprovalGenerateRouteDialog);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setters / refs
  const setLayersApprovalGenerateRouteDialog = useAppStore.getState().setLayersApprovalGenerateRouteDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { setMapObjects } = useMapObjects();
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  const [layerName, setLayerName] = useState("Route");

  return (
    <Dialog.Root modal={false} open={!!layersApprovalGenerateRouteDialog} closeOnInteractOutside={false}>
      <Portal>
        <Dialog.Positioner
          style={{
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 9999,
          }}
        >
          <Dialog.Content
            style={{
              pointerEvents: "auto",
            }}
          >
            <Dialog.Header>
              <Dialog.Title>Route Name</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Input placeholder="Enter layer name" value={layerName} onChange={(v) => setLayerName(v.target.value)} />
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    layersApprovalGenerateRouteDialog?.resetStyles();
                    setLayersApprovalGenerateRouteDialog(null);
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>

              <Button
                onClick={() => {
                  const randomColor = getRandomLightColor();

                  loadGeojsonTypeAsync({
                    originalCameraControls,
                    geojsonData: layersApprovalGenerateRouteDialog?.geojson,
                    fileName: layerName,
                    viewerRef,
                    setMapObjects,
                    defaultGeojsonStyle,
                    basicGeojsonStyle,
                    defaultOsmStyle,
                    isEdited: true,
                    zoomToDataSource: false,
                    savedStyles: {
                      style_type: "dashed",
                      style_pattern: "dashed",
                      label_interval: null,
                      label_visible: false,
                      label_text_size: null,
                      label_offset: null,
                      label_text_color: null,
                      style_fill_color: randomColor,
                      style_fill_pattern: "",
                      style_stroke_width: 4,
                      style_outline_color: randomColor,
                      selected_tags_for_label: null,
                      style_invisible_default: false,
                    },
                  });

                  showToast("Generate Route Mode Deactivated", Type.NOTIFICATION.INFO);
                  showToast("Created Route Layer", Type.NOTIFICATION.SUCCESS);

                  layersApprovalGenerateRouteDialog?.resetStyles();
                  setLayersApprovalGenerateRouteDialog(null);
                }}
              >
                Save
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger
              asChild
              onClick={() => {
                layersApprovalGenerateRouteDialog?.resetStyles();
                setLayersApprovalGenerateRouteDialog(null);
              }}
            >
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersApprovalGenerateRoute;
